<template>
    <div class="row flex-grow">
        <div class="col-lg-10 mx-auto">
            <div class="auth-form-light text-left pl-5 pr-5 pb-5">
                <div class="brand-logo text-right">
                    <img :src="'/media/aform-logo-black.png'" alt="Coachingclub.lu">
                </div>

                <div>
                    <p>
                        <strong>TERMS AND CONDITIONS:</strong><br>
                        By beginning this AFORM program, you agree to the following terms and conditions.
                    </p>

                    <p>
                        <strong>PHYSICAL CONDITION & INJURY:</strong><br> Because physical exercise can be strenuous and subject to risk of serious injury,
                        AFORM urges you to obtain a physical examination from a doctor before using any exercise equipment or participating in any exercise activity.
                        You (each member, guest, or participant) agree that if you engage in any physical exercise or activity, you do so entirely at your own risk.
                        You agree that you are voluntarily participating in these activities, training sessions and workouts and assume all risks of injury, illness, or death.
                    </p>

                    <p>
                        This waiver and release of liability includes, without limitation, all injuries which may occur, regardless of negligence, as a result of;
                        (a) your use of equipment delivered by AFORM and your participation in any activity, workout, program, personal training or instruction,
                        (b) the sudden and unforeseen malfunctioning of any equipment (c) our instruction, training, supervision, or dietary recommendations and (d) any online or virtual training.
                    </p>

                    <p>
                        You acknowledge that you have carefully read this "waiver and release" and fully understand that it is a release of liability.
                        You expressly agree to release and dischargeAFORM s.à r.l. and all affiliates, employees, coaches, representatives, successors, or assigns, from any
                        and all claims or causes of action and you agree to voluntarily give up or waive any right that you may otherwise have
                        to bring a legal action against AFORM for negligence, personal injury or property damage.
                    </p>

                    <p>
                        <strong>PAYMENT & FEES:</strong><br> All purchases of the AFORM online membership are NON-REFUNDABLE unless otherwise stated in writing by AFORM s.à r.l. Manager Jeff Paulus.
                        Users must cancel their account by logging into the platform and opt to cancel prior to their next monthly billing cycle if they do not wish to continue.
                        AFORM is not responsible for canceling user subscriptions, and is not required to provide refunds if a user fails to do so.
                        By purchasing access to the AFORM OnlineCoaching Club you agree to the above verbiage.
                        The above aforementioned programs require a recurring payment of 29,00€ per month or 24,00€ per month in the second year of membership.
                    </p>

                    <p>
                        <strong>PROGRAM ACCESS:</strong><br> AFORM Online Coaching Club is not a physical product.
                        AFORM online content can be accessed through a secure website/app after the consumer has completed purchased and has created their unique username and password combination.
                        This content cannot be accessed or distributed via any other method.
                    </p>

                    <p>
                        <strong>EQUIPMENT:</strong><br> Our goal is to have only satisfied customers.
                        If you find any piece of equipment delivered unsatisfactory in any way, please send a mail to the AFORM general inbox; office@aform.lu and an AFORM member will do his best to assist.
                        Any piece of equipment delivered by AFORM must be returned in unused condition to receive full credit.
                        AFORM cannot be held accountable for lost, stolen or damaged packages. AFORM is not responsible for any piece of equipment that is lost or damaged.
                        AFORM will not refund any costs. We do our best to deliver the equipment within the first month of membership.
                        We deliver anywhere in Luxembourg, but only in Luxembourg.
                    </p>

                    <p>
                        <strong>AGE:</strong><br> If the participant of any AFORM online content is under 18 years of age, these Terms and Conditions MUST
                        be accepted (on the participant’s behalf) by the participant’s parent or legal guardian.
                    </p>

                    <p>
                        <strong>DISCUSSION AND QUESTIONS:</strong><br> All users are to post respectable content within the platform.
                        Inappropriate content within the community platform will not be tolerated, and failure to adhere to these standards will result in immediate cancellation
                        of access to the online platform. AFORM Online Coaching Club content is not a personalized platform, however the possibility
                        to exchange and discuss is available for users and AFORM staff members engage to respond to general online questions.
                        AFORM is not liable for any unanswered posts or questions, nor does AFORM guarantee to provide specific 1:1 personal coaching.
                        A good faith effort will be made on behalf of AFORM to address as many content-related questions as possible,
                        and cannot by law provide medical or legal advice of any sort. Online clients are welcome to submit any unanswered discussion forum questions to the AFORM general inbox; office@aform.lu
                        and an AFORM member will do their best to assist.
                    </p>

                    <p>
                        <strong>ACCOUNT SECURITY:</strong><br> You are responsible for maintaining the confidentiality of your username and password and will be held fully liable
                        for all activities that occur under your username and password. You shall immediately notify us of any unauthorized use of your username or password or any other breach of security.
                        AFORM will not be liable for any loss or damage arising from your failure to comply with this provision.
                        You should use particular caution when accessing your account from a public or shared computer to decrease the risk of others being able to view or record your password
                        or other personal information.
                        Additionally, your account cannot be shared for multiple user access, if such activity takes
                        place you will be held fully accountable by law unless granted written consent from AFORM.
                    </p>

                    <p>
                        <strong>LIMITATIONS ON USE:</strong><br> AFORM grants to you a limited personal, non-exclusive and nontransferable
                        right and license to access the site and/or content. Unless otherwise specified in writing, the site and/or content are for your personal and non-commercial use.
                        The site and/or content including (without limitation) the content, metadata, design, organization, compilation, look and feel, workout plans,
                        exercises/programs, workout videos, coaching videos and all other protectable intellectual property available through the site and/or content (the “proprietary materials”)
                        solely belong to AFORM ́s property, or the property of our licensors, and are protected by copyright and other intellectual property laws.
                        All rights regarding the proprietary materials not expressly granted in this agreement are reserved by AFORM.
                        You may not copy, reproduce, sell, publish, distribute, display, retransmit or otherwise provide access to the proprietary materials received through the site to anyone without written consent.
                        You agree not to rearrange, modify or create derivative works using the proprietary materials. You agree not to create, scrape or display our content
                        for use on another web site or service without AFORM’s written consent. You agree not to post any content from AFORM Online Coaching Club to weblogs,
                        social media, YouTube, news groups, mail lists or electronic bulletin boards without our written consent.
                    </p>


                    <p>
                        <strong>MEDIA RELEASE:</strong><br> By agreeing to these terms and conditions,
                        you authorize AFORM the right to post all member photos/videos *if applicable*, and discussions on social media outlets,
                        websites and any other platform that AFORM deems necessary.
                    </p>


                    <p>
                        <strong>MODIFICATIONS TO AGREEMENT:</strong><br> AFORM reserves the right at any time to modify this Agreement and to impose new or additional terms or conditions on
                        your use of the online content and services. Such modifications and additional terms and conditions will be effective immediately
                        and incorporated into this Agreement. Your continued use of the online content and services will be deemed acceptance thereof.
                    </p>

                    <hr>
                    <div class="row">
                        <div class="col-md-6">
                            <router-link tag="a" class="text-primary cursor-pointer" :to="{name: 'login'}">
                                Home
                            </router-link>
                        </div>
                        <div class="col-md-6 text-right">
                            <p>
                                <i>Last update: 09.10.2020</i>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


</template>

<script>
export default {
    name: "TermsAndConditions"
}
</script>

<style scoped>

</style>
